module.exports = __webpack_public_path__ + "static/media/03_MINS-2.0-C-14 1.aedd4aa1.png";